import {
  getUser,
  getUserGroupsByCompany,
  useAuthStore,
} from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";

import { useCompany } from "./useCompany";

export function useCurrentUserGroups() {
  const { user } = useAuthStore();

  const { data: currentUser, isPending: isUserPending } = useQuery({
    queryKey: ["user", user?.id],
    queryFn: () => getUser(user?.id ?? ""),
    enabled: !!user,
  });

  const { company, isPending: isUserCompaniesPending } = useCompany();

  const { data, isPending, ...rest } = useQuery({
    queryKey: ["role", currentUser?.userName, company?.companyId],
    queryFn: () =>
      getUserGroupsByCompany(
        currentUser?.userName ?? "",
        company?.companyId ?? "",
      ),
    enabled:
      !!currentUser?.userName &&
      !!company?.companyId &&
      user?.role !== "SuperAdmin",
  });

  if (user?.role === "SuperAdmin") {
    return {
      userGroupsByLocation: [],
      isSuperAdmin: true,
      isAdmin: true,
      isPending: false,
    };
  }

  const isSuperAdmin = data?.some((item) => item.role === 1);
  const isAdmin = data?.some((item) => item.role === 1 || item.role === 2);

  return {
    userGroupsByLocation: data,
    isSuperAdmin,
    isAdmin,
    isPending: isUserPending || isUserCompaniesPending || isPending,
    ...rest,
  };
}
